import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-teach-subject-list-home',
    templateUrl: './teach-subject-list-home.component.html',
    styleUrls: ['./teach-subject-list-home.component.scss']
})
export class TeachSubjectListHomeComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
